import { useTranslation } from 'react-i18next';

import { isApiError } from '@/shared/api';

import ru from './locales/ru.json';

type ErrorKey = keyof typeof ru.errors;

// All locales have identical keys (enforced by i18n.test.ts), so ru is enough.
const KNOWN_CODES = new Set<string>(Object.keys(ru.errors));

function isKnownCode(code: string): code is ErrorKey {
  return KNOWN_CODES.has(code);
}

/**
 * Maps any thrown value to a localized message: backend/client error codes are
 * looked up in `errors.<CODE>`, everything else becomes `errors.UNKNOWN`.
 * When the backend adds an `ErrorCode`, add the key to every locale.
 */
export function useErrorMessage(): (error: unknown) => string {
  const { t } = useTranslation();
  return (error: unknown) =>
    isApiError(error) && isKnownCode(error.code) ? t(`errors.${error.code}`) : t('errors.UNKNOWN');
}
